export default __webpack_public_path__ + "static/eighth-318a0b86324418bd496be11a148498fa.jpg";